import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import CheckedOff from '@material-ui/icons/RadioButtonUncheckedOutlined';
import CheckedOn from '@material-ui/icons/CheckCircle';
import { FormControlLabel, Checkbox, Tooltip, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { toast } from 'react-toastify';
import { getParents, getCreditCardPagesUnderPage } from '../../../actions/admin/pageAction';
import OverLoading from '../../global/OverLoading';
import { Sleep } from '../../../common/util';
import { IsEmpty } from '../../../common/checks';
import { PayProcessorType, PayProcessor } from '../../../common/constants';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#000',
    color:           '#FFF',
    maxWidth:        220,
    marginTop:       -20,
    fontSize:        theme.typography.pxToRem(15),
    border:          '1px solid #dadde9',
  },
}))(Tooltip);

const checkStyleOn = {
  position:     'absolute',
  right:        5,
  bottom:       5,
  background:   '#FFF',
  color:        '#3adf2f',
  borderRadius: '100%',
  boxShadow:    '0px 0px 9px 3px rgb(58, 223, 47)',
};

const checkStyleOff = {
  position:     'absolute',
  right:        5,
  bottom:       5,
  background:   'rgb(255 255 255 / 0.70)',
  color:        '#000000',
  borderRadius: '100%',
};

let selectedItems = [];
const groupCreditCards = [];
const totalCreditCards = [];
const PayProcessorCheckbox = {
  [PayProcessorType.Mastercard]: 'mastercardCheckbox',
  [PayProcessorType.Visa]:       'visaCheckbox',
  [PayProcessorType.Amex]:       'amexCheckbox',
  [PayProcessorType.UnionPay]:   'unionPayCheckbox',
};
const checkboxToPayProcesorMap = Object.entries(PayProcessorCheckbox).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

class PromoCreditCard extends Component {
  constructor(props) {
      super(props);
      this.state = {
        pageType:           this.props.page.type,
        isLoading:          true,
        selectAll:          false,
        selectAllOnly:      true,
        expand:             false,
        allCheckbox:        false,
        mastercardCheckbox: false,
        visaCheckbox:       false,
        amexCheckbox:       false,
        unionPayCheckbox:   false,
        promoCreditCards:   [],
        parentCreditCards:  [],
      };
  }

  async componentDidMount() {
    if ((this.props.page.parentId === null && this.props.page.type !== 'Credit Card') || (this.props.page.parentId !== null && this.props.page.type !== 'Credit Card')) {
      // IS PARENT/NON-PARENT && NON-CC PAGE TYPE
      const fetchAllCreditCards = async () => {
        try {
          const fetchAllParentPages = await this.props.getParents();
          const parentCreditCards = fetchAllParentPages.length > 0 ? _.filter(fetchAllParentPages, (data) => data.type === 'Credit Card') : [];
          const creditCardPagesData = this.props.promoCreditCardsData;

          // set state for select all each credit card
          parentCreditCards.forEach((creditCard) => {
            this.setState({ [creditCard.id]: false });
          });

          // set credit cards parent pages
          this.setState({ parentCreditCards }, () => {
            this.setState({ isLoading: false });
            if (parentCreditCards.length > 0) {
              const self = this;
              _.map(this.state.parentCreditCards, (creditCard) => {
                const promise = new Promise((resolve) => {
                  const res = self.props.getCreditCardPagesUnderPage(creditCard.id);
                  resolve(res);
                });

                promise.then((data) => {
                  const key = creditCard.name;
                  const findObj = _.some(groupCreditCards, { [key]: data });

                  if (findObj === false) {
                    groupCreditCards.push({ [key]: data, id: creditCard.id, count: data.length });
                    totalCreditCards.push(data.length);
                    self.onCreditCardChanged(selectedItems);
                  }
                });
              });

              // pass a postId to fetch existing data.
              if (creditCardPagesData.length > 0) {
                _.forEach(creditCardPagesData, (value) => {
                  // check if fetch data exist in state if yes, push as Selected item.
                  const checkIfFetchDataExist = _.some(creditCardPagesData, { id: value.id, name: value.name });
                  if (checkIfFetchDataExist) {
                    if (_.some(selectedItems, { id: value.id, name: value.name }) === false) {
                      selectedItems.push({ parentId: value.parentId, payProcessor: value.payProcessor, id: value.id, name: value.name, logo: value.logo });
                    }
                  }
                  self.onCreditCardChanged(selectedItems);
                });
              }
            }
          });
          await Sleep(500);
          if (selectedItems.length === _.sum(totalCreditCards)) {
            this.setState({ allCheckbox: true });
            groupCreditCards.forEach((creditCard) => {
              this.setState({ [creditCard.id]: true });
            });
          } else {
            groupCreditCards.forEach((creditCard) => {
              const parentId = creditCard.id;

              // Count all the data with the same parentId in selectedItems
              const itemCount = selectedItems.filter((selectedItem) => selectedItem.parentId === parentId).length;
              if (itemCount === creditCard.count) {
                this.setState({ [creditCard.id]: true });
              }
            });
          }
          for (const selectedItem of selectedItems) {
            this.handlePayProcessorFilters(selectedItem);
          }
        } catch (e) {
          console.log('Error occured on promoCreditCard', e);
          toast.error('Error was occured when fetching data. Please contact admin');
        }
      };
      fetchAllCreditCards(this.props.page.id);
    } else {
      // IS PARENT && CC PAGE TYPE
      const fetchCreditCards = async (id) => {
        try {
          const allCreditCardsPagesByCCParent = await this.props.getCreditCardPagesUnderPage(id);
          const data = _.map(allCreditCardsPagesByCCParent, _.partialRight(_.pick, ['id', 'name', 'logo', 'parentId', 'payProcessor']));
          const creditCardPagesData = this.props.promoCreditCardsData;

            // set credit cards data.
            this.setState({ promoCreditCards: data }, () => { this.setState({ isLoading: false }); });

            await Sleep(200);
            if (data.length > 0) {
              const self = this;
              // pass a postId to fetch existing data.
              if (creditCardPagesData.length > 0) {
                _.forEach(creditCardPagesData, (value) => {
                  // check if fetch data exist in state if yes, push as Selected item.
                  const checkIfFetchDataExist = _.some(data, { id: value.id, name: value.name });
                  if (checkIfFetchDataExist) {
                    if (_.some(selectedItems, { id: value.id, name: value.name }) === false) {
                      selectedItems.push({ id: value.id, payProcessor: value.payProcessor, name: value.name, logo: value.logo });
                    }
                  }
                  self.onCreditCardChanged(selectedItems);
                });
              }
            }
            if (selectedItems.length === data.length) {
              this.setState({ allCheckbox: true });
            }
        } catch (e) {
          console.log('Error occured on promoCreditCard', e);
          toast.error('Error was occured when fetching data. Please contact admin');
        }
      };
      fetchCreditCards(this.props.page.id);
    }
  }

  componentWillUnmount() {
    if (!IsEmpty(selectedItems)) {
      selectedItems = [];
    }
  }

  onCreditCardChanged = (data) => {
    this.props.onCreditCardChanged(data);

    // simple checking for the selected items in array if empty hide deselect
    if (selectedItems.length === 0) { this.setState({ selectAll: false, selectAllOnly: true }); } else { this.setState({ selectAllOnly: true }); }
    if (selectedItems.length === this.state.promoCreditCards.length) { this.setState({ selectAll: true, selectAllOnly: false }); }
  }

  handleSelected = (data) => {
    const isDataAlrSelected = _.some(selectedItems, { id: data.id, name: data.name });
    if (isDataAlrSelected === true) {
      _.remove(selectedItems, { id: data.id });
      this.setState({ [data.parentId]: false });
      if (this.state.allCheckbox) {
        this.setState({ allCheckbox: false });
      }
    } else {
      selectedItems.push({ parentId: data.parentId, payProcessor: data.payProcessor, id: data.id, name: data.name });

      if (IsEmpty(this.state.promoCreditCards)) {
        const count = selectedItems.filter((item) => item.parentId === data.parentId).length;
        const parentCreditCard = groupCreditCards.find((groupData) => groupData.id === data.parentId);
        if (count === parentCreditCard.count) {
          this.setState({ [parentCreditCard.id]: true });
          if (selectedItems.length === _.sum(totalCreditCards)) {
            this.setState({ allCheckbox: true, mastercardCheckbox: true, visaCheckbox: true, amexCheckbox: true, unionPayCheckbox: true });
          }
        }
      } else if (selectedItems.length === this.state.promoCreditCards.length) {
        this.setState({ allCheckbox: true, mastercardCheckbox: true, visaCheckbox: true, amexCheckbox: true, unionPayCheckbox: true });
      }
    }
    this.handlePayProcessorFilters(data);
    this.onCreditCardChanged(selectedItems);
  }

  handleExpand = (panel) => (event, isExpanded) => {
    this.setState({ expand: isExpanded ? panel : false });
  };

  getFilters = (mastercardCheckbox, visaCheckbox, amexCheckbox, unionPayCheckbox) => {
    const payProcessorFilter = [];
    if (mastercardCheckbox) {
      payProcessorFilter.push(PayProcessorType.Mastercard);
    }
    if (visaCheckbox) {
      payProcessorFilter.push(PayProcessorType.Visa);
    }
    if (amexCheckbox) {
      payProcessorFilter.push(PayProcessorType.Amex);
    }
    if (unionPayCheckbox) {
      payProcessorFilter.push(PayProcessorType.UnionPay);
    }
    return payProcessorFilter;
  }

  getUpdatedPayProcessorState = (affectedFilters) => {
    const updatedState = {};
    for (const filter of affectedFilters) {
      const selectedFilteredCount = selectedItems.filter((item) => (item.payProcessor || '').includes(filter)).length;
      let totalCountByPayProcessor = 0;
      for (const group of groupCreditCards) {
        totalCountByPayProcessor += group[Object.keys(group)[0]].filter((item) => (item.payProcessor || '').includes(filter)).length;
      }
      updatedState[PayProcessorCheckbox[filter]] = selectedFilteredCount === totalCountByPayProcessor;
    }
    return updatedState;
  }

  handlePayProcessorFilters = (selectedCreditCard) => {
    // Check or uncheck pay processor filter when each item is clicked
    if (!IsEmpty(selectedCreditCard.payProcessor)) {
      const affectedFilters = PayProcessor.filter((filter) => (selectedCreditCard.payProcessor || '').includes(filter));
      const updatedState = this.getUpdatedPayProcessorState(affectedFilters);
      this.setState(updatedState);
    }
  }

  handleSelectAll = (e) => {
    this.setState({ isLoading: true });

    const prevCheckboxState = this.state[e.target.name];

    let updatedState;
    if (e.target.name !== 'allCheckbox') {
      const affectedFilter = checkboxToPayProcesorMap[e.target.name];

      // make sure selected items that have been selected and has nothing to do with the filter are not affected
      selectedItems = selectedItems.filter((data) => !(data.payProcessor || '').includes(affectedFilter));

      updatedState = { [e.target.name]: !prevCheckboxState };
    } else {
      selectedItems.splice(0, selectedItems.length);

      updatedState = {
        allCheckbox:        !prevCheckboxState,
        mastercardCheckbox: !prevCheckboxState,
        visaCheckbox:       !prevCheckboxState,
        amexCheckbox:       !prevCheckboxState,
        unionPayCheckbox:   !prevCheckboxState,
      };
    }

    this.setState(updatedState, () => {
      const { allCheckbox, mastercardCheckbox, visaCheckbox, amexCheckbox, unionPayCheckbox } = this.state;
      if (_.some([allCheckbox, mastercardCheckbox, visaCheckbox, amexCheckbox, unionPayCheckbox], (item) => item)) {
        // Get the filters
        const payProcessorFilter = this.getFilters(mastercardCheckbox, visaCheckbox, amexCheckbox, unionPayCheckbox);

        // Update all state for each parent credit cards
        this.state.parentCreditCards.forEach((creditCard) => {
          this.setState({ [creditCard.id]: allCheckbox });
        });

        const isSelected = (data) => (
          allCheckbox || _.some(payProcessorFilter, (filter) => (data.payProcessor || '').includes(filter)))
          && !selectedItems.find((item) => data.id === item.id);

        // Add all credit cards to selectedItems
        if (groupCreditCards.length > 0) {
          for (const group of groupCreditCards) {
            for (const data of group[Object.keys(group)[0]]) {
              if (isSelected(data)) {
                selectedItems.push({ parentId: data.parentId, payProcessor: data.payProcessor, id: data.id, name: data.name });
              }
            }
            this.setState({ isLoading: false });
          }
        } else {
          for (const data of this.state.promoCreditCards) {
            if (isSelected(data)) {
              selectedItems.push({ parentId: data.parentId, payProcessor: data.payProcessor, id: data.id, name: data.name });
            }
          }
          this.setState({ isLoading: false });
        }
      } else {
        // Update all state for each parent credit cards
        this.state.parentCreditCards.forEach((creditCard) => {
          this.setState({ [creditCard.id]: false });
        });
        this.setState({ isLoading: false });
      }

      this.onCreditCardChanged(selectedItems);
    });
  }

  handleSelectEach = (id) => {
    this.setState({ isLoading: true });

    const previousParentState = this.state[id];
    this.setState({ [id]: !previousParentState }, () => {
      if (this.state[id]) {
        if (groupCreditCards.length > 0) {
          _.map(groupCreditCards, (group) => {
            group[Object.keys(group)[0]].map((data) => {
              if (data.parentId === id) {
                selectedItems.push({ parentId: data.parentId, payProcessor: data.payProcessor, id: data.id, name: data.name });
              }
            });
            this.setState({ isLoading: false });
          });
        } else {
          this.state.promoCreditCards.map((data) => {
            if (data.parentId === id) {
              selectedItems.push({ parentId: data.parentId, payProcessor: data.payProcessor, id: data.id, name: data.name });
            }
          });
          this.setState({ isLoading: false });
        }
        if (selectedItems.length === _.sum(totalCreditCards)) {
          this.setState({ allCheckbox: true });
        }
        this.onCreditCardChanged(selectedItems);
      } else {
        selectedItems = selectedItems.filter((data) => data.parentId !== id);
        this.setState({ isLoading: false });
        if (this.state.allCheckbox) {
          this.setState({ allCheckbox: false });
        }
        this.onCreditCardChanged(selectedItems);
      }
      // Check or uncheck pay processor filters when entirety of each of their group got affected
      const creditCardGroup = groupCreditCards.find((group) => group.id === id);
      if (creditCardGroup) {
        const affectedFilters = [];
        for (const filter of PayProcessor) {
          for (const data of creditCardGroup[Object.keys(creditCardGroup)[0]]) {
            if (!affectedFilters.includes(filter) && (data.payProcessor || '').includes(filter)) {
              affectedFilters.push(filter);
              break;
            }
          }
        }
        const updatedState = this.getUpdatedPayProcessorState(affectedFilters);
        this.setState(updatedState);
      }
    });
  }

  render() {
    const statePromoCreditCards = groupCreditCards.length > 0 ? groupCreditCards : this.state.promoCreditCards;
    return (
      <div>
        { this.state.isLoading && <OverLoading /> }

        { statePromoCreditCards.length > 0 && (
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg-6 col-xl-4">
                <FormControlLabel
                  control={<Checkbox name="allCheckbox" checked={this.state.allCheckbox} onChange={this.handleSelectAll} />}
                  label="Select all banks"
                />
              </div>
              <div className="col-12 col-lg-6 col-xl-4">
                <FormControlLabel
                  control={<Checkbox name="mastercardCheckbox" checked={this.state.mastercardCheckbox} onChange={this.handleSelectAll} />}
                  label="Select all Mastercards"
                />
              </div>
              <div className="col-12 col-lg-6 col-xl-4">
                <FormControlLabel
                  control={<Checkbox name="visaCheckbox" checked={this.state.visaCheckbox} onChange={this.handleSelectAll} />}
                  label="Select all Visa"
                />
              </div>
              <div className="col-12 col-lg-6 col-xl-4">
                <FormControlLabel
                  control={<Checkbox name="amexCheckbox" checked={this.state.amexCheckbox} onChange={this.handleSelectAll} />}
                  label="Select all Amex"
                />
              </div>
              <div className="col-12 col-lg-6 col-xl-4">
                <FormControlLabel
                  control={<Checkbox name="unionPayCheckbox" checked={this.state.unionPayCheckbox} onChange={this.handleSelectAll} />}
                  label="Select all UnionPay"
                />
              </div>
            </div>
          </div>
        ) }

        <div className="d-flex justify-content-end align-items-center" style={{ fontSize: '18px' }}>
          Selected
          {' '}
          <span style={{ background: '#d12c2c' }} className="badge badge-secondary ml-1">
            { selectedItems.length }
            {' '}
            /
            {' '}
            {
              groupCreditCards.length > 0 ? _.sum(totalCreditCards) : this.state.promoCreditCards.length
            }
          </span>
        </div>
        <div className="mt-4">
          { groupCreditCards.length > 0
            ? _.map(_.filter(groupCreditCards, (creditCard) => creditCard.count > 0), (creditCard, key) => (
              <div key={key} className="mb-3">
                <Accordion square expanded={this.state.expand === `panel${key}`} onChange={this.handleExpand(`panel${key}`)}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content">
                    <Typography>
                      <strong>
                        { Object.keys(creditCard)[0] }
                      </strong>
                      {' '}
                      &nbsp; (
                      { creditCard[Object.keys(creditCard)[0]].length }
                      )
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails style={{ marginTop: 10 }}>
                    <>
                      <div onClick={() => this.handleSelectEach(creditCard.id)} style={{ position: 'absolute', top: 40 }}>
                        <FormControlLabel
                          control={<Checkbox checked={!!this.state[creditCard.id]} />}
                          label="Select All"
                        />
                      </div>
                      <div className="row" style={{ width: '100%' }}>
                        { _.sortBy(creditCard[Object.keys(creditCard)[0]], 'name').map((data, index) => (
                          <HtmlTooltip title={data.name} key={index}>
                            <div
                              onClick={() => this.handleSelected(data)}
                              style={{ position: 'relative' }}
                              className="col-md-2 mb-5 px-2"
                            >
                              <div
                                style={{
                                  position:     'relative',
                                  background:   '#EEE',
                                  width:        85,
                                  height:       85,
                                  borderRadius: 5,
                                }}
                              >
                                {data.logo && (
                                  <img
                                    src={data.logo}
                                    alt={data.name}
                                    style={{
                                      borderRadius: 5,
                                      cursor:       'pointer',
                                      width:        85,
                                      height:       'auto',
                                    }}
                                  />
                                )}
                                {_.some(selectedItems, { id: data.id }) === true ? (
                                  <CheckedOn style={checkStyleOn} />
                                ) : (
                                  <CheckedOff style={checkStyleOff} />
                                )}
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span
                                  style={{
                                    display:    'block',
                                    marginTop:  10,
                                    fontSize:   '11px',
                                    fontWeight: 'bold',
                                    color:      '#727272',
                                  }}
                                >
                                  {data.name}
                                </span>
                                {data.payProcessor && (
                                  <span style={{ color: 'green' }}>
                                    {`(${data.payProcessor})`}
                                  </span>
                                )}
                              </div>
                            </div>
                          </HtmlTooltip>
                        ))}
                      </div>
                    </>
                  </AccordionDetails>
                </Accordion>
              </div>
            ))
            : (
              <Accordion square expanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content">
                  <Typography>
                    <strong>{ this.props.page.name }</strong>
                    {' '}
                    &nbsp; (
                    { statePromoCreditCards.length }
                    )
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  { statePromoCreditCards.length > 0
                    ? (
                      <div className="row" style={{ width: '100%' }}>
                        { statePromoCreditCards.map((data, index) => (
                          <HtmlTooltip title={data.name} key={index}>
                            <div onClick={() => this.handleSelected(data)} className="col-md-2 mb-5">
                              <div style={{ position: 'relative', background: '#EEE', width: 85, height: 85, borderRadius: 5 }}>
                                { data.logo && <img src={data.logo} alt={data.name} style={{ borderRadius: 5, cursor: 'pointer', width: 85, height: 'auto' }} />}
                                { _.some(selectedItems, { id: data.id, name: data.name }) === true
                                  ? <CheckedOn style={checkStyleOn} />
                                  : <CheckedOff style={checkStyleOff} />}
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ display: 'block', marginTop: 10, fontSize: '11px', fontWeight: 'bold', color: '#727272' }}>{data.name}</span>
                                {
                                  data.payProcessor && (
                                    <span style={{ color: 'green' }}>
                                      {data.payProcessor}
                                    </span>
                                  )
                                }
                              </div>
                            </div>
                          </HtmlTooltip>
                        ))}
                      </div>
                    ) : 'There are no subsidiaries under this brand.' }
                </AccordionDetails>
              </Accordion>
            )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getParents:                  () => dispatch(getParents()),
  getCreditCardPagesUnderPage: (id) => dispatch(getCreditCardPagesUnderPage(id)),
});

PromoCreditCard.propTypes = {
  page: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ])).isRequired,
  promoCreditCardsData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ])).isRequired,
  getParents:                  PropTypes.func.isRequired,
  getCreditCardPagesUnderPage: PropTypes.func.isRequired,
  onCreditCardChanged:         PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(PromoCreditCard);
